<div class="parameters-page" *ngIf="isBaseRoute()">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">{{ isCreateRoute() ? 'CREAR PARÁMETRO' : 'PARÁMETROS' }}</h1>
                <p class="page-subtitle text-muted" *ngIf="!isCreateRoute()">
                    Gestione parámetros del sistema: cree, edite y controle la configuración de parámetros
                </p>
            </div>
            <div class="header-actions">
                <button 
                    mat-raised-button 
                    color="primary" 
                    (click)="onCreateParameter()"
                    matTooltip="Crear nuevo parámetro">
                    <mat-icon>add</mat-icon>
                    Nuevo
                </button>
            </div>
        </div>
    </div>

    <mat-card class="data-card">
        <mat-card-content>
            <div class="parameters-list-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort>

                        <!-- Clave Column -->
                        <ng-container matColumnDef="key">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-0">
                                Clave
                            </th>
                            <td mat-cell *matCellDef="let element" class="pl-0">
                                <div class="parameter-info">
                                    <h6 class="mt-0 mb-0">{{element.key}}</h6>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Valor Column -->
                        <ng-container matColumnDef="value">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Valor
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <code>{{element.value}}</code>
                            </td>
                        </ng-container>

                        <!-- Descripción Column -->
                        <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Descripción
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.description || '-'}}
                            </td>
                        </ng-container>

                        <!-- Estado Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Estado
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="trinta-badge fw-medium d-inline-block" *ngIf="element.status === 'active'">
                                    Activo
                                </span>
                                <span class="trinta-badge fw-medium onHand d-inline-block" *ngIf="element.status === 'inactive'">
                                    Inactivo
                                </span>
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="text-end pr-0"></th>
                            <td mat-cell *matCellDef="let element" class="text-end pr-0">
                                <div class="action">
                                    <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" (click)="editParameter(element)">
                                        <i class="ri-edit-line"></i>
                                    </button>
                                    <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" (click)="deleteParameter(element)">
                                        <i class="ri-delete-bin-line"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<router-outlet></router-outlet>

